// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
    min-width: 600px;
    display: flex;
    flex-direction: column;
    
    background-color: var(--bg-card);
    color: var(--texto-principal);
    border: 1px solid var(--color-borders);
    box-shadow: var(--sombra-card);
}

.modal-body.email-viewer {
    flex-grow: 1;
    overflow-y: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
}

.email-meta {
    padding: 15px 30px;
    border-bottom: 1px solid var(--color-borders);
    flex-shrink: 0;
    background-color: var(--bg-card);
}

.email-meta p {
    margin: 10px 0;
    font-size: 0.95rem;
    color: var(--color-gray-text);
}

.email-meta strong {
    color: var(--texto-principal);
    margin-right: 5px;
}

.modal-header h3 {
    color: var(--primary-blue);
    font-size: 1.5rem;
    font-weight: 600;
}

.email-body-content {
    background-color: var(--bg-input); 
    
    padding: 20px 30px;
    margin: 20px 30px;
    
    border: 1px solid var(--color-borders);
    border-radius: 8px;
    
    line-height: 1.6;
    font-size: 1rem;
    color: var(--texto-principal);
    width: auto;
    box-sizing: border-box;
}

.modal-email-view-footer {
    display: flex;
    justify-content: center;
    gap: 15px;
    padding-top: 20px;
    padding-bottom: 25px;
    border-top: 1px solid var(--color-borders);
    margin-top: 0;
    background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/ModalVistaCorreo/modalVistaCorreo.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;;IAEtB,gCAAgC;IAChC,6BAA6B;IAC7B,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;;IAEjC,kBAAkB;IAClB,iBAAiB;;IAEjB,sCAAsC;IACtC,kBAAkB;;IAElB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,0CAA0C;IAC1C,aAAa;IACb,6BAA6B;AACjC","sourcesContent":[".modal-content {\r\n    min-width: 600px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    \r\n    background-color: var(--bg-card);\r\n    color: var(--texto-principal);\r\n    border: 1px solid var(--color-borders);\r\n    box-shadow: var(--sombra-card);\r\n}\r\n\r\n.modal-body.email-viewer {\r\n    flex-grow: 1;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.email-meta {\r\n    padding: 15px 30px;\r\n    border-bottom: 1px solid var(--color-borders);\r\n    flex-shrink: 0;\r\n    background-color: var(--bg-card);\r\n}\r\n\r\n.email-meta p {\r\n    margin: 10px 0;\r\n    font-size: 0.95rem;\r\n    color: var(--color-gray-text);\r\n}\r\n\r\n.email-meta strong {\r\n    color: var(--texto-principal);\r\n    margin-right: 5px;\r\n}\r\n\r\n.modal-header h3 {\r\n    color: var(--primary-blue);\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.email-body-content {\r\n    background-color: var(--bg-input); \r\n    \r\n    padding: 20px 30px;\r\n    margin: 20px 30px;\r\n    \r\n    border: 1px solid var(--color-borders);\r\n    border-radius: 8px;\r\n    \r\n    line-height: 1.6;\r\n    font-size: 1rem;\r\n    color: var(--texto-principal);\r\n    width: auto;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.modal-email-view-footer {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n    padding-top: 20px;\r\n    padding-bottom: 25px;\r\n    border-top: 1px solid var(--color-borders);\r\n    margin-top: 0;\r\n    background-color: transparent;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
